import instance from './axios'

// GET请求封装
const get = (url, data, custom = {}) => {
  return new Promise((resolve, reject) => {
    instance.get(url, {params: data, custom: custom}).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// POST请求封装
const post = (url, data, custom = {}) => {
  return new Promise((resolve, reject) => {
    instance.post(url, data, {custom: custom}).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

const http = {get, post}

export default http

